import React, { useContext } from 'react';
import { DropdownContext } from './CustomDropdown';
import styles from './Dropdown.module.css';

export const CustomDropdownMenu = ({ children, className = '' }) => {
    const { isOpen, position } = useContext(DropdownContext);

    if (!isOpen) return null;

    return (
        <div className={`${styles.menu} ${styles[position]} ${className}`}>
            {children}
        </div>
    );
};
